(($, Drupal) => {
  Drupal.behaviors.analyticsTableWidthMobile = {
    attach: function () {
      const container = document.querySelector(
        ".olex-analytics-table-container"
      );
      if (!container) return;
      const line = document.createElement("div");
      line.className = "right-edge-line";
      container.appendChild(line);
      function positionLine() {
        const scrollWidth = container.scrollWidth;
        const offset = 230;
        const x = scrollWidth - offset;
        line.style.left = `${x}px`;
      }
      positionLine();

      // Store the timeout ID so we can reset it
      let resizeTimeoutId;
      // Create a ResizeObserver
      const resizeObserver = new ResizeObserver(() => {
        // Clear any existing timer if the container is still resizing
        if (resizeTimeoutId) {
          clearTimeout(resizeTimeoutId);
        }
        // Set a 5s debounce
        resizeTimeoutId = setTimeout(() => {
          positionLine();
        }, 5000);
      });
      resizeObserver.observe(container);
    },
  };
})(jQuery, Drupal);
